import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { Router } from '@angular/router';
import { projectInsuranceContent } from './data/content';
import { ToastrService } from 'ngx-toastr';
import { ProjectInsuranceService } from './project-insurance.service';
import { ProjectInsuranceFormComponent } from './components/project-insurance-form/project-insurance-form.component';

@Component({
    selector: 'app-project-insurance',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        FooterComponent,
        HeaderComponent,
        ProjectInsuranceFormComponent,
    ],
    encapsulation: ViewEncapsulation.None,
    templateUrl: './project-insurance.component.html',
    styleUrl: './project-insurance.component.scss',
})
export class ProjectInsuranceComponent implements OnInit {
    selectedLanguage: any = 'en';
    closeTostr: string;
    content: any = projectInsuranceContent;
    isLoading: boolean = false;

    constructor(
        private _projectInsuraceService: ProjectInsuranceService,
        private _router: Router,
        private toastr: ToastrService
    ) {}

    ngOnInit(): void {
        this.selectedLanguage = this.readLocalStorageValue('language');
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
    }

    readLocalStorageValue(key: string) {
        let value = localStorage.getItem(key);
        return value;
    }

    sendProjectInsuranceLead(data) {
        data.orgCode = 'LIBE';
        if (!this.isLoading) {
            this.isLoading = true;
            this._projectInsuraceService
                .sendProjectInsuranceData(data)
                .subscribe({
                    next: (res) => {
                        this.isLoading = false;
                        this._router.navigate(['/insurance/success'], {
                            queryParams: { source: 'project-insurance' },
                            state: { id: res?.id },
                        });
                    },
                    error: (err) => {
                        this.isLoading = false;
                        this.toastr.error(err.error.message, 'Error');
                    },
                });
        }
    }
}
